import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [lang, setLang] = useState<'uk' | 'ru'>('uk');
  const [isDark, setIsDark] = useState(() =>
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled(scrollY > 50);
      setShowScrollTop(scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => setIsDark(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [isDark]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white dark:bg-[#121212]">
      <Navigation isScrolled={isScrolled} lang={lang} setLang={setLang} isDark={isDark} setIsDark={setIsDark} />
      <Hero lang={lang} />
      <Services lang={lang} />
      <About lang={lang} />
      <Testimonials lang={lang} />
      <Contact lang={lang} />
      <Footer lang={lang} />

      {/* Scroll to top button */}
      <button
        onClick={scrollToTop}
        aria-label="Наверх"
        className={`fixed right-6 bottom-8 z-50 w-11 h-11 flex items-center justify-center rounded-full
          bg-white/80 dark:bg-[#2A2A2A]/80 backdrop-blur-sm
          border border-[#E0E0E0] dark:border-[#3A3A3A]
          shadow-md hover:shadow-lg
          text-[#7EC8E3] hover:text-white hover:bg-[#7EC8E3] dark:hover:bg-[#7EC8E3]
          transition-all duration-300 cursor-pointer
          ${showScrollTop ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}
        `}
      >
        <i className="ri-arrow-up-line text-[20px]"></i>
      </button>
    </div>
  );
}